import { render, staticRenderFns } from "./BCGovFooter.vue?vue&type=template&id=55384acb&scoped=true"
import script from "./BCGovFooter.vue?vue&type=script&lang=js"
export * from "./BCGovFooter.vue?vue&type=script&lang=js"
import style0 from "./BCGovFooter.vue?vue&type=style&index=0&id=55384acb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55384acb",
  null
  
)

export default component.exports